// extracted by mini-css-extract-plugin
module.exports = {"pagePresenter":"EmptyMessage_pagePresenter__3b19D","icon":"EmptyMessage_icon__3NLJQ"};